"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettings = void 0;
var settings_1 = require("../private/services/settings/settings");
Object.defineProperty(exports, "PrivateSettings", { enumerable: true, get: function () { return settings_1.PrivateSettings; } });
//# sourceMappingURL=index.js.map